import React from 'react';
import { faPiggyBank } from '@fortawesome/pro-regular-svg-icons/faPiggyBank';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function PiggyBankRegularIcon(props) {
  return <FontAwesomeIcon icon={faPiggyBank} {...props} />;
}
